export default __webpack_public_path__ + "static/media/login-background.e04e4f10.jpg";